<template>
  <div class="box4-page">
    <div class="fcp-title">哪些人可以考？</div>
    <div class="fcp-text">如果您是下列的任意一种情况，FCP认证考试不可忽视</div>
    <div class="swiper-content">
      <swiper :options="swiperOption" ref="mySwiper2" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="box4-cont">
            <p>{{ item }}</p>
            <img :src="require(`../../../assets/coursePage/fcp/box4/icon-phone-${index}.png`)" alt />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="btn-box">
      <div class="btn" @click="zixun('测一下我是否符合')">测一下我是否符合</div>
    </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  export default {
    name: '',
    components: {
      swiper,
      swiperSlide,
    },
    data() {
      return {
        list: [
          '我是在校大学生/暂未就业，以后想往数据行业发展',
          '我是在职员工、央企&国企类科技员、运用FineReport、Kettle 等产品进行报表项目落地的人员',
          '我想面试加分、涨薪、跳槽、丰富简历履历，赋能数据能力，为自己增加谈判筹码'
        ],
        swiperOption: {
          loop: true, // 循环模式选项
          spaceBetween: -10,
          autoplay: true,
          centeredSlides: true,
          slidesPerView: "auto"
        },
      }
    },
    methods:{
      zixun(name){
        this.mai("帆软FCP认证&培训","测一下我是否符合",0,null)
        this.clickZiXun()
      }
    }
  }
</script>

<style lang="scss" scoped>
.box4-page{
  height: 764px;
  background-image: url(../../../assets/coursePage/fcp/box4/box4-bg.png);
  background-size: cover;
  padding: 80px 0 88px;
  box-sizing: border-box;
  .swiper-content{
    position: relative;
    margin-top: 48px;
    .box4-cont{
      width: 558px;
      height: 292px;
      background-image: url(../../../assets/coursePage/fcp/box4/box4-cont-bg.png);
      background-size: 100% 100%;
      padding: 32px;
      box-sizing: border-box;
      position: relative;
      p{
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #24375C;
        line-height: 44px;
      }
      img{
        position: absolute;
        width: 80px;
        height: 80px;
        left: 32px;
        bottom: 32px;
      }
    }

    .swiper-slide {
      width: 558px;
      height: 292px;
      display: flex;
      align-items: center;
      transform: scale(.8);
      transition: .5s transform;
    }
    .swiper-slide-active {
      transform: scale(1);
    }
  }

  .btn-box{
    margin-top: 48px;
    display: flex;
    justify-content: center;
    .btn{
      width: 686px;
      height: 96px;
      background: linear-gradient(270deg, #98BDFF 0%, #4386FE 100%);
      border-radius: 48px;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 96px;
      text-align: center;
    }
  }
}
</style>